import { render } from "./author-identity.vue?vue&type=template&id=d588c0c2&scoped=true"
import script from "./author-identity.vue?vue&type=script&lang=js"
export * from "./author-identity.vue?vue&type=script&lang=js"

import "./author-identity.vue?vue&type=style&index=0&id=d588c0c2&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d588c0c2"]])

export default __exports__